/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import ReactColorPicker from './react-color-picker';
import CustomColorPicker from './custom-color-picker';
import { setStyle } from '../utility';

import { getThemes } from '../utility';
const colorParse = require('color-parse');
const { Component, Fragment } = wp.element;

class ReactMultiColorPicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			colLabel: '',
		};

		this.updateLabel = this.updateLabel.bind(this);
	}

	componentDidMount() {}

	componentDidUpdate() {}

	clearColors = async () => {
		const { cols, attributes, setAttributes } = this.props;

		//const custom_themes = await getThemes("custom_accordion_expand_themes");
		//console.log("PROPS", this.props, JSON.parse(custom_themes));

		//console.log('clearColors: ', d.toLocaleTimeString());

		if (
			!confirm(
				'Are you sure? This will reset colors back to theme defaults.'
			)
		) {
			return;
		}

		//console.log('OK, LETS DELETE...', d.toLocaleTimeString());

		const tmpObj = {};
		cols.forEach((el) => {
			tmpObj[el.update] = '';
		});

		//console.log(tmpObj);
		setAttributes(tmpObj); // should this be setStyle() ?
	};

	updateLabel(label, update = '') {
		const {
			attributes: { faqThemeCustomizedStatus },
			cols,
			attributes,
			setAttributes,
			rawCoreThemes,
		} = this.props;

		if ('' !== update) {
			const defaultColor = rawCoreThemes[update].default; // Default color value.
			const currentColor = attributes[update]; // Current color value.
			let inHeritedLabel = '';

			//console.log("COMPARE DEFAULTS", defaultColor, currentColor);

			// Only show inherited on FAQ theme label if the current value was originally an inherited value (in the default theme) and it matches the current color. i.e. hasn't been modified in a custom theme, or manually by the user.
			if (
				rawCoreThemes[update].inherited !== undefined &&
				defaultColor === currentColor
			) {
				inHeritedLabel = ' (inherited)';
			}

			const newState = { ...this.state };

			newState.colLabel = `${label}${inHeritedLabel}`;
			this.setState(newState);
		}
	}

	handleHoverOut = () => {
		this.updateLabel('');
	};

	render() {
		const {
			attributes: { faqThemeCustomizedStatus },
			cols,
			attributes,
			setAttributes,
			rawCoreThemes,
		} = this.props;

		const { colLabel } = this.state;

		const iconHeading = css`
			margin-bottom: 5px !important;

			& > span {
				visibility: hidden;
				line-height: 19px;
				width: 12px;
				height: 12px;
				font-size: 12px;
				margin-left: 5px;
				font-weight: bold;
				color: green;
				/*color: white;*/
			}

			&:hover > span {
				visibility: visible;
			}
		`;

		const multiColorPicker = css`
			display: flex;
			flex-wrap: wrap;
			margin-bottom: 15px;

			li {
				margin-bottom: 0px;
			}
		`;

		const cpContainer = css`
			display: block;
			position: relative;
			width: 100%;
		`;

		const colPickerLabel = css`
			font-size: 12px;
			font-style: italic;
			position: absolute;
			top: -18px;
		`;

		const colPickerLabelWrapper = css`
			position: relative;
		`;

		const inheritedLabel = faqThemeCustomizedStatus ? '' : '';

		return (
			<div css={cpContainer} onMouseLeave={this.handleHoverOut}>
				{/* <h2 css={iconHeading} className="override-colors-heading">CSS colors <span onClick={() => this.clearColors()} title="Reset colors" className="dashicons dashicons-image-rotate"></span></h2> */}
				<h2 css={iconHeading} className="override-colors-heading">
					Colors
				</h2>
				<ul css={multiColorPicker}>
					{cols.map((val, index) => {
						//console.log(val, index);
						return (
							<li key={index}>
								<CustomColorPicker
									parentProps={this.props}
									colIndex={index}
									title={val.label}
									update={val.update}
									attribute={val.value}
									attributes={attributes}
									setAttributes={setAttributes}
									updateLabel={this.updateLabel}
									onChange={(newVal, update, props) =>
										setStyle(update, newVal, props)
									}
								/>
							</li>
						);
					})}
				</ul>
				<div css={colPickerLabelWrapper}>
					<p css={colPickerLabel}>{colLabel}</p>
				</div>
			</div>
		);
	}
}

export default ReactMultiColorPicker;
